module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title235"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429932165_tp01",
      "id": "toctitle232",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_frontMatter",
    attrs: {
      "href": "#/e9781429932165_fm01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Introduction")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932165_c01",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("One")])]), _vm._v(" - "), _c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Using Astrology to Plan Your Big Day")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c01#title3",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Astrology: A")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Really")])]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("Brief History")])])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c01#title4",
      "id": "toctitle4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A Little Astrology Goes a Long Way")])])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c01#title5",
      "id": "toctitle5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sun Signs: A Tour of the Zodiac")])])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c01#title6",
      "id": "toctitle6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Four Personality Types: Nature’s Organization System")])])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c01#title7",
      "id": "toctitle7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Three Qualities: Your Modus Operandi")])])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c01#title8",
      "id": "toctitle8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Planning by the Stars: Choosing the Perfect Wedding Day")])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932165_c02",
      "id": "toctitle9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Two")])]), _vm._v(" - "), _c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bridal Signs")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c02#title10",
      "id": "toctitle10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Fire Elements: Aries, Leo, Sagittarius")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c02#title14",
      "id": "toctitle14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Earth Elements: Taurus, Virgo, Capricorn")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c02#title18",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Air Elements: Gemini, Libra, Aquarius")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c02#title22",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Water Elements: Cancer, Scorpio, Pisces")])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932165_c03",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Three")])]), _vm._v(" - "), _c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Getting Started: Where Astrology and Weddings Meet")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c03#title27",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Organize Yourself")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c03#title32",
      "id": "toctitle32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Getting Your Groom Involved")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c03#title37",
      "id": "toctitle37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bringing Up the Budget")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c03#title42",
      "id": "toctitle42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Setting Your Priorities")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c03#title47",
      "id": "toctitle47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Number of Guests")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c03#title52",
      "id": "toctitle52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Making Early Decisions")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c03#title57",
      "id": "toctitle57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Gift Registry")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c03#title62",
      "id": "toctitle62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Invitations and the Printing")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c03#title67",
      "id": "toctitle67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Tackling the Legalities")])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932165_c04",
      "id": "toctitle72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Four")])]), _vm._v(" - "), _c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Look of the Bride, Groom, and Bridal Party")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c04#title73",
      "id": "toctitle73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Wedding Dress")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c04#title78",
      "id": "toctitle78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Completing the Look: Shoes, Accessories, Hair, and Makeup")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c04#title83",
      "id": "toctitle83",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Groom’s Attire")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c04#title88",
      "id": "toctitle88",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dressing the Bridal Party")])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932165_c05",
      "id": "toctitle93",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Five")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "imageinline"
  }, [_vm._v(" Pre-Wedding Parties")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c05#title94",
      "id": "toctitle94",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Bridal Shower")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c05#title99",
      "id": "toctitle99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Bachelorette Party")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c05#title104",
      "id": "toctitle104",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Rehearsal Dinner")])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932165_c06",
      "id": "toctitle109",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Six")])]), _vm._v(" - "), _c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Designing an Unforgettable Ceremony")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c06#title110",
      "id": "toctitle110",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Officiant and Ritual")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c06#title115",
      "id": "toctitle115",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Readings and Vows")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c06#title120",
      "id": "toctitle120",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Creating the Perfect Ambience")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c06#title125",
      "id": "toctitle125",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Flowers")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c06#title130",
      "id": "toctitle130",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Music")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c06#title135",
      "id": "toctitle135",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Photography and Videography")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c06#title140",
      "id": "toctitle140",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Transportation")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c06#title145",
      "id": "toctitle145",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Morning Of")])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932165_c07",
      "id": "toctitle150",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Seven")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "imageinline"
  }, [_vm._v(" A Reception That Suits Your Sign")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c07#title151",
      "id": "toctitle151",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Setting the Tone")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c07#title156",
      "id": "toctitle156",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Seating Your Guests")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c07#title161",
      "id": "toctitle161",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Food and Drink")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c07#title166",
      "id": "toctitle166",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Flowers")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c07#title171",
      "id": "toctitle171",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Music")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c07#title176",
      "id": "toctitle176",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("First-Dance Selections and Styles")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c07#title181",
      "id": "toctitle181",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Cake")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c07#title186",
      "id": "toctitle186",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Toasts and Speeches")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c07#title191",
      "id": "toctitle191",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Favors and Crafts")])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429932165_c08",
      "id": "toctitle196",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chapter")]), _vm._v(" "), _c('em', {
    staticClass: "i"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Eight")])]), _vm._v(" - "), _c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Your Honeymoon")])])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c08#title197",
      "id": "toctitle197",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Choosing the Perfect Destination")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c08#title202",
      "id": "toctitle202",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Practical Decisions")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c08#title207",
      "id": "toctitle207",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Romantic Activities for Day and Night")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429932165_c08#title212",
      "id": "toctitle212",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('span', {
    staticClass: "imageinline"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Adding the Perfect Surprises!")])])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('p', [_c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429932165_bm01",
      "id": "toctitle218",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Happily Ever "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Afterword")])]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_c('span', {
    staticClass: "imageinline"
  }, [_vm._v(" Being Mrs. Right!")])])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_alsoby",
    attrs: {
      "href": "#/e9781429932165_als01",
      "id": "toctitle217",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Also by STACEY WOLF")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781429932165_ack01",
      "id": "toctitle231",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgments")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_aboutAuthorPage",
    attrs: {
      "href": "#/e9781429932165_ata01",
      "id": "toctitle236",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("About the Author")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429932165_cop01",
      "id": "toctitle233",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d60f07da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429932165_toc01.vue
// module id = 63
// module chunks = 0